<template>
  <b-container fluid>
    <b-row v-if="!isLoading" class="justify-content-center">
      <b-col lg="8">
        <!-- breadcrumb -->
        <BaseBreadCrumb :items="breadcrumbs" />

        <!-- Learning unit name -->
        <div class="display-4 font-weight-bold">
          {{ learningUnit.name }}
        </div>

        <!-- title -->
        <div class="h5 font-weight-bold mt-u6">
          Create description Part 2 : Work Examples/Artifacts/Evidence
        </div>

        <!-- form -->
        <PostPartDescriptionForm
          class="mt-u8"
          :is-saving="isSaving"
          :data="data"
          @save="save"
          @cancel="goToPreviousPage"
        />
      </b-col>
    </b-row>
    <div v-else class="d-flex justify-content-center">
      <b-spinner label="Loading..." variant="dark" />
    </div>
  </b-container>
</template>

<script>
import PostPartDescriptionForm from '@/components/Post/PostPartDescriptionForm.vue';
import BaseBreadCrumb from '@/components/base-components/BaseBreadCrumb';
import LearningUnit from '@/models/LearningUnit';

export default {
  components: {
    PostPartDescriptionForm,
    BaseBreadCrumb
  },

  data() {
    return {
      isLoading: true,
      isSaving: false,
      data: {
        description: ''
      }
    };
  },

  computed: {
    learningUnitId() {
      return this.$route.params.learningUnitId;
    },

    learningUnit() {
      return LearningUnit.find(this.learningUnitId);
    },

    postId() {
      return this.$route.params.postId;
    },

    part() {
      return this.$route.params.partType;
    },

    breadcrumbs() {
      return [
        {
          key: 'user-dashboard',
          name: 'User Dashboard',
          to: {
            name: 'user-dashboard'
          }
        },
        {
          key: 'design-planning-info',
          name: this.learningUnit.name,
          to: {
            name: 'design-planning/info',
            params: {
              learningUnitId: this.learningUnitId
            },
            query: {
              tab: 'evaluation-assessments'
            }
          }
        },
        {
          key: 'work-examples-description',
          name: 'Work Examples Description',
          active: true
        }
      ];
    }
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.isLoading = true;

      /* fetch learning unit */
      if (!this.learningUnit) {
        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      }
      this.data.description = this.learningUnit.partDescription(this.part);

      this.isLoading = false;
    },

    async save(data) {
      this.isSaving = true;
      const payload = { properties: {} };
      payload.properties[`description_part_${this.part}`] = data.description;
      await LearningUnit.api().updateLearningUnit(this.learningUnitId, payload);
      this.isSaving = false;
      this.goToPreviousPage();
    },

    goToPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;
        this.$router.push({ path: previousPath });
      } else {
        this.$router.push({
          name: 'design-planning/info',
          params: {
            learningUnitId: this.learningUnitId
          },
          query: {
            tab: 'evaluation-assessments'
          }
        });
      }
    }
  }
};
</script>
